import {
  keepPreviousData,
  MutationCache,
  QueryCache,
  QueryClient,
} from '@tanstack/react-query';

import { getApiErrorMessage } from '@shared/lib';
import { useSnackbarStore } from '@shared/ui/snackbar';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query.meta?.silentError) return;
      useSnackbarStore
        .getState()
        .show({ message: getApiErrorMessage(error), severity: 'error' });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      if (mutation.meta?.silentError) return;
      useSnackbarStore
        .getState()
        .show({ message: getApiErrorMessage(error), severity: 'error' });
    },
  }),
  defaultOptions: {
    queries: {
      placeholderData: keepPreviousData,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});
